{
  "004f5d5275089ec5": "Exportar mis turnos pasados",
  "010077a338ae711d": "Lo que obtendrás",
  "04c66ddd3a12f26a": "Trimestres PBJ",
  "0a0576d381558739": "No hay datos de gráficos disponibles para este lugar de trabajo aún.",
  "1208ec01f223c616": "Página anterior",
  "14d74158a8d17afe": "Rango de Fechas",
  "1559a79d9a98cc94": "Enviar por correo mis turnos pasados",
  "18e83b61f2fd9ee7": "No hay turnos disponibles para esta vista en este momento.",
  "19766ed6ccb2f4a3": "Cancelar",
  "19c73a5cdf346d96": "Profesional",
  "24059f06f65217e2": "Enviar informe por correo electrónico",
  "29ccb51a8ac08325": "Llenado semanal, demanda de último minuto y resultados de tarifas dinámicas.",
  "2e544a292f6979ed": "Turno",
  "32334126e7a4727b": "No se encontraron turnos en el rango de fechas seleccionado.",
  "34c4406f444e3055": "Profesionales únicos que ya han trabajado aquí.",
  "3982f0e7ebe9b019": "Lugares de trabajo hijos",
  "3aaa8e968bd46b42": "Hubo un error al generar su informe. Por favor, inténtelo de nuevo o contacte al soporte.",
  "3c81e27e32356966": "Total de turnos de Clipboard completados en este lugar de trabajo.",
  "3e69ed92dacf9336": "No pudimos cargar las tendencias de informes en este momento.",
  "50ca140508e4c2fe": "Solicita un CSV para cualquier período de tiempo y obtén la misma carga útil completa de exportación que el proceso anterior, incluyendo identificaciones profesionales únicas y horas día a día.",
  "53779f0aaec9f64b": "Todos los lugares de trabajo secundarios están incluidos por defecto. Seleccione uno o más para limitar el informe.",
  "54a0e8c17ebb21a1": "Error",
  "6581fd2fc435ddf1": "Profesionales contratados de por vida",
  "6a74f97da23273c8": "La descarga de su informe ha comenzado.",
  "6c68ad180780bcaa": "Descargar informe",
  "730fa2bbb7eed5be": "Su informe será enviado a su correo en solo unos minutos.",
  "7602b82667695f57": "Combine los lugares de trabajo seleccionados en un solo archivo en lugar de un archivo por lugar de trabajo.",
  "784d9cd76a8882e8": "Solicitar exportación para lugares de trabajo hijos",
  "7c7523eda3b9df7e": "Semana de inicio de turno",
  "7d9eb7acb13e2462": "Cerrar",
  "7f6ef2a4b8b68158": "Solicitar informe",
  "84a6279baecd797d": "Utilice la exportación para inspeccionar el historial completo",
  "868dd3bb3de9cd6d": "Próximas 48 horas.",
  "9ad3c6fd490260a2": "Qué incluye este informe",
  "9c30df66653ecc6c": "Consolidar en un solo informe",
  "9d9afc4eb9108e8d": "Los informes incluyen las fechas de inicio y fin seleccionadas, identificaciones profesionales únicas, horas diarias con divisiones a medianoche, y el resto de la carga útil de exportación existente.",
  "aaf89a2e8dd2e9c7": "Página {{page}}",
  "abf8fcb96d8d7ccb": "Página {{page}} de {{totalPages}}",
  "b1fa104b9bf0635e": "Informes",
  "b70c92965b2bef81": "Turnos llenos próximos",
  "b8afa9ad74a3bcdf": "T{{quarterNumber}} {{fiscalYear}}",
  "b9f85f36d4fd1e96": "No pudimos cargar esta métrica en este momento.",
  "bcd892c6af2e7a95": "Turnos no llenos próximos",
  "c08ac736a5e29c29": "Página siguiente",
  "c0bbbd310ce1d6a3": "Abrir mis profesionales",
  "c2b7ea6e50679e34": "Solicitar exportación",
  "c522ba8398594f8c": "Turnos reservados que comienzan en las próximas 48 horas.",
  "c7f761b38b197daa": "{{count}} seleccionado",
  "d241f9dd52b2518f": "Todos los lugares de trabajo hijos",
  "d56bd8d171bea796": "Necesidades de cobertura abiertas en las próximas 48 horas.",
  "d63b2b691e7e7479": "Formato de archivo",
  "e4bb9f1ece9af926": "Inicio",
  "e96595c5612813ad": "Generaremos su archivo {{fileType}} para el período seleccionado y se lo enviaremos a la dirección asociada con su cuenta.",
  "ee89233169887439": "Turnos de Clipboard de por vida",
  "f00b68c521eff8c8": "Generaremos un CSV para el período seleccionado y se lo enviaremos a la dirección asociada con su cuenta.",
  "f11f7b221d0149fa": "Exportar Turnos Pasados",
  "f308f941bd16022b": "Tendencias de Desempeño",
  "f4db1e48476f6075": "Fin",
  "ff7912a16f6ad42f": "Enviar horarios de lugares de trabajo hijos por correo electrónico"
}
